/**
 * The playout's refusal of a row's clip, as the relay parks it (`blockedReason`), sorted for the operator's words
 * (ADR 094): the clip is not in the playout's library; the change touches a clip on air or next and waits; anything
 * else is said as the playout said it.
 */
export type RefusalKind = 'missing' | 'on-air' | 'other';

export function refusalKind(reason: string): RefusalKind {
  if (/NOT_FOUND|not found|append not reflected/i.test(reason)) return 'missing';
  if (/\b(ON AIR|ON_AIR|NEXT|CUED)\b/.test(reason)) return 'on-air';
  return 'other';
}
